import LocationFormButtons from './LocationFormButtons';

export default LocationFormButtons;
